import type { MutableRefObject } from 'react';
import { useRef, useCallback } from 'react';

import type { PageTreeStateUpdater } from '@confluence/page-tree-refresh-state-container';

import { CONTAINER_HOME_ID } from './paths.ts';

export const useScrollTree = ({
	view,
}: {
	view: any;
}): {
	pageTreeUpdater: MutableRefObject<PageTreeStateUpdater | undefined>;
	scrollTree: () => void;
} => {
	const pageTreeUpdater = useRef<PageTreeStateUpdater>();

	const scrollTree = useCallback((): void => {
		if (view === CONTAINER_HOME_ID && pageTreeUpdater.current) {
			pageTreeUpdater.current.scrollToCurrentPage();
		}
		/* eslint-disable-next-line react-hooks/exhaustive-deps */
	}, [view, pageTreeUpdater.current]);

	return {
		pageTreeUpdater,
		scrollTree,
	};
};
